import React, { useEffect, useState } from "react";
import ImagerApi from "../../api/ImagerApi";
import HeaderButton from "../Header/HeaderButton";
import SwitchButton from "../Buttons/SwitchButton";
type Props = {
  freerunCapture: boolean;
  imagerIdentifier: string;
  disabled?:boolean;
};
export default function LiveStreamHeaderButton({ freerunCapture, imagerIdentifier, disabled=false }: Props) {
  const [isLiveStreamChanging, setIsLiveStreamChanging] = useState(false);
  const [isLiveStreaming, setIsLiveStreaming] = useState(freerunCapture);

  useEffect(() => {
    setIsLiveStreaming(freerunCapture);
  }, [freerunCapture]);

  const liveStreamingClick = () => {
    setIsLiveStreamChanging(true);
    setIsLiveStreaming(!freerunCapture);
    if (freerunCapture) {
      ImagerApi.stopStreaming(imagerIdentifier).finally(() => setIsLiveStreamChanging(false));
    } else {
      ImagerApi.startStreaming(imagerIdentifier).finally(() => setIsLiveStreamChanging(false));
    }
  };

  return (
    <HeaderButton
      disabled={isLiveStreamChanging || disabled}
      id={"LIVE_STREAM"}
      label={"Live Stream"}
      content={<SwitchButton isOn={isLiveStreaming} withLetter={true} onToggle={() => {}} />}
      onClick={liveStreamingClick}
    />
  );
}
